import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const brandIcons = [
  <a href='https://github.com/speak2donsimon'>
    <FontAwesomeIcon size='lg' color='black' icon={["fab", "github"]} />
  </a>,
  <a href='https://twitter.com/Techemptys'>
    <FontAwesomeIcon size='lg' color='lightblue' icon={["fab", "twitter"]} />
  </a>,
  <a href='./medium'>
    <FontAwesomeIcon size='lg' color='black' icon={["fab", "medium"]} />
  </a>,
  <a href='./facebook'>
    <FontAwesomeIcon size='lg' icon={["fab", "facebook"]} />
  </a>,
  <a href='./medium'>
    <FontAwesomeIcon size='lg' color='lightblue' icon={["fab", "linkedin"]} />
  </a>
];

export default brandIcons;
